export default function PHP_array_chunk() {
  return (
    <div>
      <h1>PHP_array_chunk</h1>
    </div>
  );
}
